module.exports = __webpack_public_path__ + "assets/34IconMoreVertical.5c5cfa0c01e6346e4987dfcd9581524a.svg";